<template>
  <el-main class="Edit-main">
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">创意名称：</el-col>
      <el-col :span="21" class="value-col">{{ entity.ideaName }}</el-col>
    </el-row>
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">投放单元：</el-col>
      <el-col :span="21" class="value-col">{{ entity.putUnitInfo.putUnitName }}</el-col>
    </el-row>
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">创意类型：</el-col>
      <el-col :span="21" class="value-col">{{ entity.ideaTypeInfo.ideaTypeName }}</el-col>
    </el-row>
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">出价类型：</el-col>
      <el-col :span="21" class="value-col">{{ entity.bidTypeText }}</el-col>
    </el-row>
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">目标出价：</el-col>
      <el-col :span="21" class="value-col">{{ entity.simulateBidText }}</el-col>
    </el-row>

    <template v-for="(item, index) in entity.assetsList">
      <el-row class="row-gap" :key="index" v-if="item.assetsId===1">
        <el-col :span="3" class="label-col">Icon：</el-col>
        <el-col :span="21" class="value-col"><el-image v-if="item.value.url" :src="item.value.url" :preview-src-list="[item.value.url]" style="width: 64px;height: 64px;" fit="contain"></el-image></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===2">
        <el-col :span="3" class="label-col">Logo：</el-col>
        <el-col :span="21" class="value-col"><el-image v-if="item.value.url" :src="item.value.url" :preview-src-list="[item.value.url]" style="width: 64px;height: 64px;" fit="contain"></el-image></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===3">
        <el-col :span="3" class="label-col">主图片：</el-col>
        <el-col :span="21" class="value-col"><el-image v-if="item.value.url" :src="item.value.url" :preview-src-list="[item.value.url]" style="border:1px solid #ccc; width: 300px;height: 200px;" fit="contain"></el-image></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===4">
        <el-col :span="3" class="label-col">图片二：</el-col>
        <el-col :span="21" class="value-col"><el-image v-if="item.value.url" :src="item.value.url" :preview-src-list="[item.value.url]" style="border:1px solid #ccc; width: 300px;height: 200px;" fit="contain"></el-image></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===5">
        <el-col :span="3" class="label-col">图片三：</el-col>
        <el-col :span="21" class="value-col"><el-image v-if="item.value.url" :src="item.value.url" :preview-src-list="[item.value.url]" style="border:1px solid #ccc; width: 300px;height: 200px;" fit="contain"></el-image></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===6">
        <el-col :span="3" class="label-col">标题：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===7">
        <el-col :span="3" class="label-col">描述：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===8">
        <el-col :span="3" class="label-col">评分：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===9">
        <el-col :span="3" class="label-col">好评数：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===10">
        <el-col :span="3" class="label-col">落地页链接：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===11">
        <el-col :span="3" class="label-col">APP名称：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===12">
        <el-col :span="3" class="label-col">APP下载链接：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===13">
        <el-col :span="3" class="label-col">打开应用URL：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===14">
        <el-col :span="3" class="label-col">APP包名：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===15">
        <el-col :span="3" class="label-col">展示监控：</el-col>
        <el-col :span="21" class="value-col"><ul><li v-for="(link, index) in item.value.split(',')" class="track-link" :key="index">{{ link }}</li></ul></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===16">
        <el-col :span="3" class="label-col">点击监控：</el-col>
        <el-col :span="21" class="value-col"><ul><li v-for="(link, index) in item.value.split(',')" class="track-link" :key="index">{{ link }}</li></ul></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===17">
        <el-col :span="3" class="label-col">视频：</el-col>
        <el-col :span="21" class="value-col">
          <video v-if="item.value.video_url" :src="item.value.video_url" style="border:1px solid #ccc; width: 300px;height: 200px" muted autoplay loop>您的浏览器不支持 video 标签</video>
        </el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===18">
        <el-col :span="3" class="label-col">APP版本：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===19">
        <el-col :span="3" class="label-col">APP开发者：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===20">
        <el-col :span="3" class="label-col">APP功能描述URL：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===21">
        <el-col :span="3" class="label-col">APP隐私政策URL：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===22">
        <el-col :span="3" class="label-col">APP权限列表URL：</el-col>
        <el-col :span="21" class="value-col">{{ item.value }}</el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===23">
        <el-col :span="3" class="label-col">下载开始监控：</el-col>
        <el-col :span="21" class="value-col"><ul><li v-for="(link, index) in item.value.split(',')" class="track-link" :key="index">{{ link }}</li></ul></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===24">
        <el-col :span="3" class="label-col">下载完成监控：</el-col>
        <el-col :span="21" class="value-col"><ul><li v-for="(link, index) in item.value.split(',')" class="track-link" :key="index">{{ link }}</li></ul></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===25">
        <el-col :span="3" class="label-col">安装开始监控：</el-col>
        <el-col :span="21" class="value-col"><ul><li v-for="(link, index) in item.value.split(',')" class="track-link" :key="index">{{ link }}</li></ul></el-col>
      </el-row>
      <el-row class="row-gap" :key="index" v-if="item.assetsId===26">
        <el-col :span="3" class="label-col">安装完成监控：</el-col>
        <el-col :span="21" class="value-col"><ul><li v-for="(link, index) in item.value.split(',')" class="track-link" :key="index">{{ link }}</li></ul></el-col>
      </el-row>
    </template>

    <el-row class="row-gap">
      <el-col :span="3" class="label-col">每日最大展示数：</el-col>
      <el-col :span="21" class="value-col">{{ entity.dayShowNum }}</el-col>
    </el-row>
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">每日最大点击数：</el-col>
      <el-col :span="21" class="value-col">{{ entity.dayClickNum }}</el-col>
    </el-row>
    <el-row class="row-gap">
      <el-col :span="3" class="label-col">备注：</el-col>
      <el-col :span="21" class="value-col">{{ entity.remark }}</el-col>
    </el-row>
  </el-main>
</template>

<script>
import ideaAPI from '../../api/idea'
import ideaTypeAPI from '../../api/ideaType'

export default {
  name: 'DetailTemplate',
  props: [ 'referer', 'id', 'object' ],
  data () {
    return {
      entity: {
        putUnitInfo: {},
        ideaTypeInfo: {},
        advertiserInfoVo: {},
        assetsList: []
      }
    }
  },
  computed: {},
  created () {
    console.log(`referer=${this.referer}, id=${this.id}`)
    console.log('object', this.object)
    if (this.referer === 'idea') {
      this.getDetail()
    } else if (this.referer === 'apply') {
      this.entity = this.object
      this.handleEntity()
    }
  },
  mounted () {},
  activated () {},
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  },
  methods: {
    close () {
      this.myOption.navigateTo(this, '/home/idea/list')
    },
    getDetail () {
      ideaAPI.getEntity({
        ideaId: this.id
      }).then(res => {
        this.entity = res.data
        this.handleEntity()
      })
    },
    handleEntity () {
      this.entity.simulateBidText = this.entity.simulateBid + ' ' + this.simulateBidUnit(this.entity.bidType)
      this.entity.bidTypeText = this.myOption.bidType.find(item => item.id === this.entity.bidType).name
      this.entity.assetsList = JSON.parse(this.entity.ideaTypeInfo.assets)
      this.entity.assetsList.forEach(item => { item['value'] = '' })
      let assets = JSON.parse(this.entity.assets)
      for (let fieldName in assets) {
        let assetId = ideaTypeAPI.toAssetId(fieldName)
        let asset = this.entity.assetsList.find(item => item.assetsId === parseInt(assetId))
        if (asset) {
          asset['value'] = assets[fieldName] || ''
        }
      }
      // console.log(this.entity)
    },
    simulateBidUnit (bidType) {
      if (bidType === 3) {
        return '元/千次展示'
      } else if (bidType === 2) {
        return '元/点击'
      } else if (bidType === 4 || bidType === 5) {
        return '元/用户成本'
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.row-gap {
  margin-bottom: 20px; /* 统一设置行间距 */
}

/* 最后一行不需要间距，可以去掉 */
.row-gap:last-child {
  margin-bottom: 0;
}

.label-col {
  text-align: right;
  font-size: 15px;
  line-height: 15px;
  color: #333333;
}

.value-col {
  font-size: 13px;
  line-height: 13px;
  color: #808080;
}

.track-link {
  margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/idea/DetailTemplate.vue